import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import sharedTheme from 'themes/styleguide/nation/Auth/Shared.module.scss';
import NetworkLink from 'components/NetworkLink';
import ProvidersList from './components/ProvidersList';
import SearchInput from './components/SearchInput';
import Style from './VideoProviderSearch.module.scss';

export default class VideoProviderSearch extends Component {
  state = {
    searchInput: '',
    moveSideMenuToTop: false,
  };

  render() {
    const { searchInput, moveSideMenuToTop } = this.state;
    const {
      backgroundUrl,
      mvpdProviders,
      onClose,
      onProviderClick,
      preauthorizedResources,
    } = this.props;
    const { auth_searchProviderHeader: headerBarText } = window.Language;

    const containerStyle = backgroundUrl ? { backgroundImage: `url(${backgroundUrl})` } : null;
    const containerClassName = classNames(Style.container, sharedTheme.container, 'withBackground');

    return (
      <div className={containerClassName} style={containerStyle}>
        <div
          key="header-bar"
          className={classNames(
            sharedTheme.headerBarExtraPadding,
            sharedTheme.headerBarBorder,
            Style.header,
          )}
        >
          <div className={sharedTheme.headerContainer}>
            <div key="logo" className={classNames(sharedTheme.headerLogo, Style.headerLogo)}>
              <NetworkLink
                theme={sharedTheme}
                alt="Fox Nation logo"
                clickEvent={() => {
                  onClose();
                  // TODO: implement once this is requested for buythrough
                  // tealiumGlobalNavClickEvent({ text: getCurrentBrand() });
                }}
                preauthorizedResources={preauthorizedResources}
              />
            </div>

            <div className={Style.headerBarText}>{headerBarText}</div>
            <button
              aria-label="close"
              className={sharedTheme.close}
              key="close"
              onClick={onClose}
              type="button"
            />
          </div>
        </div>
        <div className={Style.content}>
          <VisibilitySensor
            onChange={isVisible => this.setState({ moveSideMenuToTop: !isVisible })}
          >
            <SearchInput
              onInputChange={e => {
                this.setState({ searchInput: e.target.value });
              }}
              input={searchInput}
            />
          </VisibilitySensor>
          <div className={Style.mvpdListContainer} scroll="video-provider-search">
            <ProvidersList
              mvpdProviders={mvpdProviders}
              query={searchInput}
              onProviderClick={onProviderClick}
              scrollToTop={() => {
                document.querySelector('[scroll="video-provider-search"]').scrollTop = 0;
              }}
              moveSideMenuToTop={moveSideMenuToTop}
            />
          </div>
        </div>
      </div>
    );
  }
}

VideoProviderSearch.defaultProps = {
  backgroundUrl: null,
  onProviderClick: () => {},
  preauthorizedResources: [],
};

VideoProviderSearch.propTypes = {
  backgroundUrl: PropTypes.string,
  mvpdProviders: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onProviderClick: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
};
